// extracted by mini-css-extract-plugin
module.exports = {"failed_container":"Failed_failed_container__3pBRO","verification_failed":"Failed_verification_failed__cXXAk","box":"Failed_box__1J1hT"};